import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    this.refreshFirst();
    this._observer = new MutationObserver(() => this.refreshFirst());
    this._observer.observe(this.element, { childList: true });
  }

  disconnect() {
    if (this._observer) {
      this._observer.disconnect();
      delete this._observer;
    }
  }

  refreshFirst() {
    const cards = Array.from(this.element.querySelectorAll('.update-card'));
    if (cards.length === 0) return;

    cards.forEach((card, idx) => {
      const isFirst = idx === 0;
      card.classList.toggle('first', isFirst);

      const content = card.querySelector('.content');
      const triggerContainer = card.querySelector('.box-title');
      const trigger = card.querySelector(
        '.expandable__trigger',
      );
      const triggerText = card.querySelector(
        "[data-expandable-target='triggerText']",
      );
      const triggerIcon = card.querySelector(
        "[data-expandable-target='triggerIcon']",
      );

      if (isFirst) {
        content.classList.remove('hidden');

        triggerContainer.removeAttribute('data-action');

        trigger.classList.add('first');

        triggerText.innerText = 'Zwiń';

        triggerIcon.classList.remove('down');
        triggerIcon.classList.add('up');
      } else {
        content.classList.add('hidden');

        triggerContainer.setAttribute('data-action', 'click->expandable#toggle');

        trigger.classList.remove('first');

        triggerText.innerText = 'Rozwiń';

        triggerIcon.classList.remove('up');
        triggerIcon.classList.add('down');
      }
    });
  }
}
